import { PaginationData, PaginationPcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { ChargeStatus, ContractSearchStatusType, ContractStatus } from '@/constants/contract';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type ContractListForPartnerParams = {
  id: string;
  searchContractDateType: string;
  startedAt: string;
  finishedAt: string;
  name: string;
  productIds: string[];
  searchContractStatusType: ContractSearchStatusType;
  searchContractStatus?: ContractStatus;
  page: number;
  size?: number;
};

export type ContractForPartner = {
  autoRenewal: boolean;
  bizType: BizType;
  chargingFinishedAt: string;
  chargingStartedAt: string;
  chargingStatus: ChargeStatus;
  contractStatus: ContractStatus;
  finishedAt: string;
  id: string;
  partnerId: string;
  partnerName: string;
  product: {
    id: string;
    code: string;
    description: string;
    isTest: boolean;
  };
  renewalPeriod: number;
  serviceName: string;
  settleId: string;
  settleName: string;
  startedAt: string;
  svcId: string;
};

export type ContractListForPartnerPagination = PaginationData<ContractForPartner[]>;

const DEFAULT_PAGE_SIZE = 25;

export const getContractListForPartner = (params: ContractListForPartnerParams) => {
  return api<PaginationPcApiResponse<ContractForPartner[]>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/contract/list/search-for-partner`,
    {
      ...params,
      size: params.size || DEFAULT_PAGE_SIZE
    }
  );
};
